import axiosClient from 'apis/axios-client';
import { AxiosResponse } from 'axios';

const GET_USERS_URL = '/AdminUser/GetUsers';
const UPDATE_USER_STATUS_URL = '/AdminUser/UpdateUserStatus';
const GET_CORE_COMMUNITY_USERS_URL = '/AdminUser/GetCoreCommunityUsers';
const GET_ELIGIBLE_COMMUNITY_USERS_URL = '/AdminUser/GetEligibleCommunityUsers';
const ADD_TO_CORE_COMMUNITY_URL = '/AdminUser/AddToCoreCommunity';
const REMOVE_FROM_CORE_COMMUNITY_URL = '/AdminUser/RemoveFromCoreCommunity';
const CREDIT_TOKENS_URL = '/AdminUser/CreditTokens';
const GET_USER_DETAILS_URL = '/AdminUser/GetUserDetails';

export const getUsers = async (
  searchTerm: string,
  filter: string,
  page: number,
  size: number
): Promise<any> => {
  try {
    const url = `${GET_USERS_URL}?searchTerm=${encodeURIComponent(searchTerm)}&filter=${encodeURIComponent(filter)}&page=${page}&size=${size}`;

    const response: AxiosResponse<any> = await axiosClient.get(url);
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching users:', error.message);
    } else {
      console.error('Unknown error fetching users');
    }
    throw error;
  }
};


export const getCoreCommunityUsers = async (
  searchTerm: string,
  page: number,
  size: number
): Promise<any> => {
  try {
    const url = `${GET_CORE_COMMUNITY_USERS_URL}?searchTerm=${encodeURIComponent(searchTerm)}&page=${page}&size=${size}`;

    const response: AxiosResponse<any> = await axiosClient.get(url);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching core community users:', error.message);
    } else {
      console.error('Unknown error fetching core community users');
    }
    throw error;
  }
};


export const getEligibleCommunityUsers = async (
  searchTerm: string,
  page: number,
  size: number
): Promise<any> => {
  try {
    const url = `${GET_ELIGIBLE_COMMUNITY_USERS_URL}?searchTerm=${encodeURIComponent(searchTerm)}&page=${page}&size=${size}`;

    const response: AxiosResponse<any> = await axiosClient.get(url);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching eligible community users:', error.message);
    } else {
      console.error('Unknown error fetching eligible community users');
    }
    throw error;
  }
};


export const addToCoreCommunity = async (
  userIds: number[]
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosClient.post(
      ADD_TO_CORE_COMMUNITY_URL,
      { userIds }
    );
    return response;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error adding users to core community:', error.message);
    } else {
      console.error('Unknown error adding users to core community');
    }
    throw error;
  }
};


export const removeFromCoreCommunity = async (
  userId: number
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosClient.post(
      REMOVE_FROM_CORE_COMMUNITY_URL,
      { userId }
    );
    return response;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error removing user from core community:', error.message);
    } else {
      console.error('Unknown error removing user from core community');
    }
    throw error;
  }
};


export const getUserDetails = async (userId: number): Promise<any> => {
  try {
    const url = `${GET_USER_DETAILS_URL}/${userId}`;

    const response: AxiosResponse<any> = await axiosClient.get(url);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching user details:', error.message);
    } else {
      console.error('Unknown error fetching user details');
    }
    throw error;
  }
};


export const creditTokens = async (
  userIds: number[],
  tokensToCredit: number
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosClient.post(
      CREDIT_TOKENS_URL,
      { userIds, tokensToCredit }
    );
    return response;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error crediting tokens:', error.message);
    } else {
      console.error('Unknown error crediting tokens');
    }
    throw error;
  }
};


export const updateUserStatus = async (
  userId: number,
  isBlocked: boolean,
  comment: string
): Promise<any> => {
  try {
    const payload = {
      userId,
      isBlocked,
      comment,
    };

    const response: AxiosResponse<any> = await axiosClient.post(
      UPDATE_USER_STATUS_URL,
      payload
    );

    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error updating user status:', error.message);
    } else {
      console.error('Unknown error updating user status');
    }
    throw error;
  }
};
